<template>
    <div
        class="flex items-center p-4 cursor-pointer"
        @click="update(!enabled)"
    >
        <UIIcon
            v-if="filter.icon"
            :icon="filter.icon"
            weight="regular"
            :size="24"
            class="mr-4 text-(--color-brand-700)"
        />
        <span class="content-md-ux-medium">
            {{ filter.title }}
        </span>
        <!-- The entire row is clickable so prevent potential issues with nested click handlers by disabling pointer events, it is still keyboard navigable so keep the event listener -->
        <DSwitch
            :model-value="enabled"
            class="scale-110 ml-auto pointer-events-none"
            text="left"
            @update:model-value="update($event)"
        />
    </div>
</template>
<script setup>
    import { DSwitch } from '@digistorm/spark'

    import UIIcon from '@/components/ui/UIIcon.vue'

    const emit = defineEmits(['update:modelValue'])

    const props = defineProps({
        filter: Object,
        modelValue: Object,
    })

    const enabled = computed(() => props.modelValue?.enabled ?? false)

    const update = (enabled) => {
        emit('update:modelValue', enabled ? { enabled } : null)
    }
</script>
